var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"product-card-badge product-card-badge--bonus"},[_vm._v("+"+_vm._s(_vm.bonusAccumulationAmount)+" Бонусов накопим")])
}
var staticRenderFns = []

export { render, staticRenderFns }